import { gql, useQuery } from '@apollo/client'

import { extractNumber } from '@cred/shared/utils'
import { currency } from '@cred/shared/formatters'

const GET_LENDERS_SUMMARY = `
  query GetLendersSummary {
    getLendersSummary(vertical: personal) {
        activeLendersCount
        maxApr
        maxLoanAmount
        minApr
        minLoanAmount
    }
}
`

export const useLendersSummary = () => {
  const { data } = useQuery(gql(GET_LENDERS_SUMMARY))

  return data?.getLendersSummary ?? {}
}

const isZero = (value, numberValue) =>
  (value === 0 && Number.isNaN(numberValue)) || numberValue === 0

export const minMaxLoanAmountValidator = (minLoanAmount, maxLoanAmount) => (value) => {
  const numberValue = extractNumber(value)
  const error = `Please enter an amount between ${currency(minLoanAmount)} and ${currency(
    maxLoanAmount,
  )}`

  if (isZero(value, numberValue) || numberValue < minLoanAmount || numberValue > maxLoanAmount) {
    return error
  }

  return undefined
}
